<script>
    import { onMount, onDestroy } from "svelte";
    import * as api from "../utiles/api";
    import { push } from "svelte-spa-router";
    import Header from "../components/Header.svelte";
    import Modal from "../components/Modal.svelte";
    import * as common from "../utiles/common.util";
    import { Camera, CameraResultType, CameraSource } from "@capacitor/camera";
    import * as store from "../stores/store";

    export let params;

    let rcept_NO = params.rcept_NO;
    let rcept_SN = params.rcept_SN;
    let sttus_nm = params.sttus_nm;
    let bcnc_NM = params.bcnc_NM;
    let sttus = "";
    let PAY_SE_NM = "";

    let RM = "";
    let btn_text = "";

    let OPERT_HOUR = "0";
    let OPERT_MIN = "0";

    let mobile_CONF_AT = "";

    let AS_INPUT_ITEM_CODE = "";
    let AS_BTRPS = "";
    let STARTDT = "";
    let COMPTDT = "";

    function getToday() {
        const now = new Date();
        const y = now.getFullYear();
        const m = String(now.getMonth() + 1).padStart(2, "0");
        const d = String(now.getDate()).padStart(2, "0");
        return `${y}-${m}-${d}`;
    }

    function parseDateToInputFormat(dtStr) {
        if (!dtStr) return getToday();
        const trimmed = String(dtStr).trim();
        if (!trimmed) return getToday();

        // 1. 이미 YYYY-MM-DD 형식인 경우
        if (/^\d{4}-\d{2}-\d{2}/.test(trimmed)) {
            return trimmed.slice(0, 10);
        }

        // 2. YYYY.MM.DD 형식인 경우
        if (/^\d{4}\.\d{2}\.\d{2}/.test(trimmed)) {
            return trimmed.slice(0, 10).replace(/\./g, "-");
        }

        // 3. MM/DD/YYYY 형식인 경우 (예: "10/20/2026")
        const slashMatch = trimmed.match(/^(\d{1,2})\/(\d{1,2})\/(\d{4})/);
        if (slashMatch) {
            const m = slashMatch[1].padStart(2, "0");
            const d = slashMatch[2].padStart(2, "0");
            const y = slashMatch[3];
            return `${y}-${m}-${d}`;
        }

        // 4. Date 객체 파싱
        const parsed = new Date(trimmed);
        if (!isNaN(parsed.getTime())) {
            const y = parsed.getFullYear();
            const m = String(parsed.getMonth() + 1).padStart(2, "0");
            const d = String(parsed.getDate()).padStart(2, "0");
            return `${y}-${m}-${d}`;
        }

        return getToday();
    }

    onMount(() => {
        const today = getToday();
        STARTDT = today;
        COMPTDT = today;

        getData();
    });

    async function getData() {
        const response = await api.get(
            `/as/${params.rcept_NO}?RCEPT_SN=${params.rcept_SN}`
        );

        if (response != null) {
            const data = response.data;

            mobile_CONF_AT = data.mobile_CONF_AT;
            sttus = data.sttus;

            if (sttus != "M") {
                if (data.pay_SE_NM == "유상") {
                    setPAY_SE_NM(`status-1`);
                } else {
                    setPAY_SE_NM(`status-2`);
                }

                RM = data.rm?.trim() || "";
                btn_text = "작업 내용 수정";

                OPERT_HOUR = data.opert_HOUR != null && data.opert_HOUR !== "" ? String(data.opert_HOUR) : "0";
                OPERT_MIN = data.opert_MIN != null && data.opert_MIN !== "" ? String(data.opert_MIN) : "0";
                AS_INPUT_ITEM_CODE = data.as_INPUT_ITEM_CODE || "";
                AS_BTRPS = (data.as_BTRPS != null && data.as_BTRPS !== "" && Number(data.as_BTRPS) > 0) ? String(data.as_BTRPS) : "";
                STARTDT = parseDateToInputFormat(data.startdt);
                COMPTDT = parseDateToInputFormat(data.comptdt);

                // [디버그 로그] 로직과 무관, 값 확인용 콘솔 출력 - 필요시 이 라인만 찾아 수정/제거
                console.log(COMPTDT);
            } else {
                setPAY_SE_NM("status-1");
                btn_text = "작업 완료";
                STARTDT = getToday();
                COMPTDT = getToday();
                AS_BTRPS = "";
            }
        }
    }

    async function saveClick() {
        let put_yn = "y";

        if (sttus != "M") {
            put_yn = "n";
        }

        const formData = {
            RCEPT_NO: rcept_NO,
            RCEPT_SN: rcept_SN,
            STTUS: sttus_nm,
            BCNC_NM: bcnc_NM,
            RM,
            put_yn,
            PAY_SE_NM,
            OPERT_HOUR,
            OPERT_MIN,
            AS_INPUT_ITEM_CODE,
            AS_BTRPS: Number(AS_BTRPS) || 0,
            STARTDT: STARTDT || getToday(),
            COMPTDT: COMPTDT || getToday(),
        };

        const response = await api.post("/as/put", formData);

        if (response != null) {
            if (Capacitor.isNativePlatform()) {
            }

            if (sttus == "M") {
                alert("A/S 처리 완료되었습니다.");
            } else {
                alert("수정 완료되었습니다.");
            }

            push(`/AsDtl/${rcept_NO}/${rcept_SN}`);
        } else {
            alert(response.msg);
        }
    }

    function setPAY_SE_NM(id) {
        if (!id || typeof id !== "string") return;
        var status = id.includes("status-") ? id.split("status-")[1] : id;

        document.querySelectorAll(".PAY_SE_NM").forEach((element) => {
            element.style.background = "#FFF";
            element.querySelectorAll("p").forEach((p) => {
                p.style.color = "#4A4A4A";
            });
        });

        const target = document.getElementById(`status-${status}`);
        if (target) {
            target.style.background = "#2D3C48";
            target.querySelectorAll("p").forEach((p) => {
                p.style.color = "#FFF";
            });
        }

        PAY_SE_NM = status;
    }

    function goBack() {
        push(`/AsDtl/${rcept_NO}/${rcept_SN}`);
    }

    // 페이지가 로드될 때 goBack 등록
    store.currentGoBack.set(goBack);

    // 페이지 벗어나면 해제
    onDestroy(() => {
        store.currentGoBack.set(null);
    });

    // --- 사용 부품 조회/선택 모달 관련 상태 및 로직 ---
    let showItemModal = false;
    let isItemLoading = false;
    let LCLASList = [];
    let searchLclasCode = "";
    let searchItemNm = "";
    let itemList = [];
    let selectedItemsMap = new Map();
    let quantities = {}; // item_CODE -> 수량(기본 1)

    // 부품 사진 팝업 모달 상태
    let showPhotoModal = false;
    let PHOTO_FILE = "";

    // 부품 2개 이상일 때 요약 및 상세 보기 관련 상태
    let showPartsDetail = false;

    $: parsedParts = AS_INPUT_ITEM_CODE
        ? AS_INPUT_ITEM_CODE.split(",").map((s) => s.trim()).filter(Boolean)
        : [];

    function removePartItem(indexToRemove) {
        const remaining = parsedParts.filter((_, idx) => idx !== indexToRemove);
        AS_INPUT_ITEM_CODE = remaining.join(", ");
    }

    async function openItemModal() {
        showItemModal = true;
        searchItemNm = "";
        searchLclasCode = "";
        selectedItemsMap = new Map();

        if (LCLASList.length === 0) {
            await getLCLAS();
        }
        await getItemList();
    }

    function closeItemModal() {
        showItemModal = false;
    }

    async function getLCLAS() {
        const response = await api.get(`/item/LCLAS`);
        if (response && response.data) {
            LCLASList = response.data;
        }
    }

    async function getItemList() {
        isItemLoading = true;
        try {
            const encodedNm = encodeURIComponent(searchItemNm.trim());
            const encodedLclas = encodeURIComponent(searchLclasCode);
            const response = await api.get(
                `/item?ITEM_NM=${encodedNm}&LCLAS_CODE=${encodedLclas}&RCEPT_NO=${rcept_NO || ""}&RCEPT_SN=${rcept_SN || ""}`
            );
            if (response && response.data) {
                itemList = response.data;
                itemList.forEach((item) => {
                    if (!quantities[item.item_CODE]) {
                        quantities[item.item_CODE] = 1;
                    }
                });
                quantities = quantities;
            } else {
                itemList = [];
            }
        } catch (e) {
            console.error(e);
            itemList = [];
        } finally {
            isItemLoading = false;
        }
    }

    function toggleItemSelection(item) {
        if (selectedItemsMap.has(item.item_CODE)) {
            selectedItemsMap.delete(item.item_CODE);
        } else {
            selectedItemsMap.set(item.item_CODE, item.item_NM);
            if (!quantities[item.item_CODE]) {
                quantities[item.item_CODE] = 1;
                quantities = quantities;
            }
        }
        selectedItemsMap = new Map(selectedItemsMap);
    }

    function selectSingleItem(item) {
        const qty = quantities[item.item_CODE] || 1;
        const itemText = `${item.item_NM} ${qty}개`;
        if (!AS_INPUT_ITEM_CODE || AS_INPUT_ITEM_CODE.trim().length === 0) {
            AS_INPUT_ITEM_CODE = itemText;
        } else {
            const parts = AS_INPUT_ITEM_CODE.split(",").map((p) => p.trim()).filter(Boolean);
            const existingIdx = parts.findIndex((p) => p.startsWith(item.item_NM));
            if (existingIdx !== -1) {
                parts[existingIdx] = itemText;
            } else {
                parts.push(itemText);
            }
            AS_INPUT_ITEM_CODE = parts.join(", ");
        }
        closeItemModal();
    }

    function confirmSelection() {
        const selectedTexts = [];
        itemList.forEach((item) => {
            if (selectedItemsMap.has(item.item_CODE)) {
                const qty = quantities[item.item_CODE] || 1;
                selectedTexts.push(`${item.item_NM} ${qty}개`);
            }
        });

        if (selectedTexts.length > 0) {
            if (!AS_INPUT_ITEM_CODE || AS_INPUT_ITEM_CODE.trim().length === 0) {
                AS_INPUT_ITEM_CODE = selectedTexts.join(", ");
            } else {
                const parts = AS_INPUT_ITEM_CODE.split(",").map((p) => p.trim()).filter(Boolean);
                selectedTexts.forEach((text) => {
                    const itemName = text.replace(/\s+\d+개$/, "");
                    const existingIdx = parts.findIndex((p) => p.startsWith(itemName));
                    if (existingIdx !== -1) {
                        parts[existingIdx] = text;
                    } else {
                        parts.push(text);
                    }
                });
                AS_INPUT_ITEM_CODE = parts.join(", ");
            }
        }
        closeItemModal();
    }

    async function viewPhoto(itemCode) {
        try {
            const response = await api.get(`/item/getItemCode/${itemCode}`);
            const rawPhoto =
                response?.data?.photo_FILE ||
                response?.data?.photo_file ||
                response?.data?.PHOTO_FILE;

            if (rawPhoto && String(rawPhoto).trim().length > 0) {
                PHOTO_FILE = common.imgCnv(rawPhoto);
                showPhotoModal = true;
            } else {
                alert("등록된 부품 이미지가 없습니다.");
            }
        } catch (e) {
            console.error(e);
            alert("이미지를 불러오는 중 오류가 발생했습니다.");
        }
    }
</script>

<Header {goBack} />

<!-- svelte-ignore a11y-missing-attribute -->
<!-- svelte-ignore a11y-click-events-have-key-events -->
<!-- svelte-ignore a11y-label-has-associated-control -->
<section class="main inner main-pad-36" style="position: relative;">
    <div class="mobile">
        <div
            style="border-bottom: 1px solid var(--line, #ECECEC); position: relative;"
        >
            <div
                class="cmn-title-left"
                style="padding-top: 20px; padding-bottom: 15px;"
            >
                <p>작업 내용 작성</p>
            </div>
        </div>

        <div class="order-status gray-width" style="width:100%;">
            <img src="resource/img/img_line.png" alt="" class="img-line" />
            <div class="status-wrap" style="height: 40px;">
                <div
                    class="status PAY_SE_NM"
                    style="margin-right: 4%; width: 50%"
                    id="status-1"
                    on:click={() => {
                        setPAY_SE_NM("status-1");
                    }}
                >
                    <div>
                        <p>유상</p>
                    </div>
                </div>

                <div
                    class="status PAY_SE_NM"
                    style="width: 50%"
                    id="status-2"
                    on:click={() => {
                        setPAY_SE_NM("status-2");
                    }}
                >
                    <div>
                        <p>무상</p>
                    </div>
                </div>
            </div>
        </div>

        <div class="cmn-input" style="margin-top: 10px; width:100%;">
            <p>출장일자</p>

            <input bind:value={STARTDT} type="date" class="cmn-date-input" />
        </div>

        <div class="cmn-input" style="margin-top: 10px; width:100%;">
            <p>완료일자</p>

            <input bind:value={COMPTDT} type="date" class="cmn-date-input" />
        </div>

        <div
            class="cmn-select gray-width"
            style="margin-top: 10px; width:100%; display: flex; align-items: center;"
        >
            <p style="width: 80px; font-size: 14px; font-weight: 600; justify-content: flex-start; padding-left: 10px; color: #4A4A4A; flex-shrink: 0;">소요시간</p>

            <select bind:value={OPERT_HOUR} style="flex: 1; height: 44px; box-sizing: border-box; border-radius: 3.5px; border: 1px solid var(--line, #ECECEC); background: #FFF; text-align: center; font-size: 14px;">
                <option value="0">0</option>
                <option value="1">1</option>
                <option value="2">2</option>
                <option value="3">3</option>
                <option value="4">4</option>
                <option value="5">5</option>
                <option value="6">6</option>
                <option value="7">7</option>
                <option value="8">8</option>
                <option value="9">9</option>
                <option value="10">10</option>
                <option value="11">11</option>
                <option value="12">12</option>
            </select>
            <p style="width: 30px; font-size: 16px; font-weight: 700; color: #4A4A4A; display: flex; justify-content: center; align-items: center; flex-shrink: 0;">:</p>
            <select bind:value={OPERT_MIN} style="flex: 1; height: 44px; box-sizing: border-box; border-radius: 3.5px; border: 1px solid var(--line, #ECECEC); background: #FFF; text-align: center; font-size: 14px;">
                <option value="0">0</option>
                <option value="30">30</option>
            </select>
        </div>

        <div class="cmn-input" style="margin-top: 10px; width:100%;">
            <p>사용부품</p>

            <div class="part-input-wrap">
                <input
                    bind:value={AS_INPUT_ITEM_CODE}
                    type="text"
                    placeholder="사용부품을 입력 또는 선택해 주세요."
                />
                <button
                    type="button"
                    class="item-select-btn"
                    on:click={openItemModal}
                >
                    부품 선택
                </button>
            </div>

            <!-- 부품이 2개 이상일 때 나타나는 요약 바 (A안) -->
            {#if parsedParts.length >= 2}
                <div class="part-summary-container">
                    <button
                        type="button"
                        class="part-summary-bar"
                        on:click={() => (showPartsDetail = !showPartsDetail)}
                    >
                        <span class="summary-text">
                            📦 <strong>{parsedParts[0]}</strong> 외 <strong>{parsedParts.length - 1}개</strong>
                        </span>
                        <span class="summary-toggle-btn">
                            {showPartsDetail ? "접기 ▲" : "목록보기 ▼"}
                        </span>
                    </button>

                    {#if showPartsDetail}
                        <div class="part-detail-dropdown">
                            <div class="part-detail-header">
                                <span>선택된 부품 목록 (총 {parsedParts.length}개)</span>
                            </div>
                            <div class="part-tags-list">
                                {#each parsedParts as part, idx}
                                    <div class="part-tag-item">
                                        <span class="part-tag-name">{part}</span>
                                        <button
                                            type="button"
                                            class="part-tag-del"
                                            title="이 부품 삭제"
                                            on:click|stopPropagation={() => removePartItem(idx)}
                                        >✕</button>
                                    </div>
                                {/each}
                            </div>
                        </div>
                    {/if}
                </div>
            {/if}
        </div>

        <div class="cmn-input" style="margin-top: 10px; width:100%;">
            <p>출장비</p>

            <input
                min="0"
                bind:value={AS_BTRPS}
                type="number"
                class="cmn-text-input"
                placeholder="출장비를 입력해 주세요. (미입력 시 0원)"
            />
        </div>

        <div
            class="cmn-textarea"
            style="margin-top: 10px; padding-bottom: 11px; border-bottom: 1px solid var(--line, #ECECEC);"
        >
            <textarea
                bind:value={RM}
                placeholder="작업 내용을 입력해주세요."
                style="margin-top: 0; height: 300px;"
            ></textarea>
        </div>

        <div class="cmn-btn cmn-btn-btm" style="margin-top: 11px;">
            <button on:click={saveClick}>{btn_text}</button>
        </div>
    </div>
</section>

{#if showItemModal}
    <!-- svelte-ignore a11y-click-events-have-key-events -->
    <div class="item-modal-overlay" on:click={closeItemModal}>
        <div class="item-modal-container" on:click|stopPropagation>
            <!-- 모달 헤더 -->
            <div class="item-modal-header">
                <h3>사용 부품 선택</h3>
                <button type="button" class="modal-close-icon" on:click={closeItemModal}>✕</button>
            </div>

            <!-- 검색 필터 영역 -->
            <div class="item-modal-search">
                <div class="search-row">
                    <select bind:value={searchLclasCode} class="modal-select" on:change={getItemList}>
                        {#each LCLASList as lclas}
                            <option value={lclas.lclas_CODE}>
                                {lclas.cl_NM.replace(/\s+/g, " ")}
                            </option>
                        {/each}
                    </select>
                </div>
                <div class="search-row" style="margin-top: 8px; display: flex; gap: 8px;">
                    <input
                        type="text"
                        bind:value={searchItemNm}
                        placeholder="부품명을 입력하세요"
                        class="modal-input"
                        on:keydown={(e) => {
                            if (e.key === "Enter") getItemList();
                        }}
                    />
                    <button type="button" class="modal-search-btn" on:click={getItemList}>
                        조회
                    </button>
                </div>
            </div>

            <!-- 부품 리스트 영역 -->
            <div class="item-modal-body scroll-custom">
                {#if isItemLoading}
                    <div class="empty-state">부품 목록을 불러오는 중입니다...</div>
                {:else if itemList.length === 0}
                    <div class="empty-state">조회된 부품이 없습니다.</div>
                {:else}
                    <div class="item-card-list">
                        {#each itemList as item}
                            <div
                                class="item-card"
                                class:selected={selectedItemsMap.has(item.item_CODE)}
                                on:click={() => toggleItemSelection(item)}
                            >
                                <div class="item-card-top">
                                    <input
                                        type="checkbox"
                                        checked={selectedItemsMap.has(item.item_CODE)}
                                        on:click|stopPropagation
                                        on:change={() => toggleItemSelection(item)}
                                    />
                                    <span class="item-name">{item.item_NM}</span>

                                    {#if item.photo_FILE_AT === "Y"}
                                        <button
                                            type="button"
                                            class="item-img-btn"
                                            on:click|stopPropagation={() => viewPhoto(item.item_CODE)}
                                        >
                                            사진 보기
                                        </button>
                                    {/if}

                                    <button
                                        type="button"
                                        class="item-pick-btn"
                                        on:click|stopPropagation={() => selectSingleItem(item)}
                                    >
                                        선택
                                    </button>
                                </div>
                                <div class="item-card-info">
                                    <span>코드: <strong>{item.item_CODE}</strong></span>
                                    {#if item.stndrd}
                                        <span>규격: {item.stndrd}</span>
                                    {/if}
                                    {#if item.untpc}
                                        <span>단가: {common.formatCurrency(item.untpc)}원</span>
                                    {/if}
                                </div>

                                <!-- 수량 조절 행 -->
                                <div class="item-card-qty-row" on:click|stopPropagation>
                                    <span class="qty-label">수량:</span>
                                    <div class="qty-control">
                                        <button
                                            type="button"
                                            class="btn-minus"
                                            on:click={() => {
                                                if ((quantities[item.item_CODE] || 1) > 1) {
                                                    quantities[item.item_CODE]--;
                                                    quantities = quantities;
                                                }
                                            }}
                                        >-</button>
                                        <input
                                            type="number"
                                            min="1"
                                            bind:value={quantities[item.item_CODE]}
                                            class="qty-input"
                                            on:change={() => {
                                                if (!quantities[item.item_CODE] || quantities[item.item_CODE] < 1) {
                                                    quantities[item.item_CODE] = 1;
                                                    quantities = quantities;
                                                }
                                            }}
                                        />
                                        <button
                                            type="button"
                                            class="btn-plus"
                                            on:click={() => {
                                                quantities[item.item_CODE] = (quantities[item.item_CODE] || 1) + 1;
                                                quantities = quantities;
                                            }}
                                        >+</button>
                                    </div>
                                    {#if item.untpc}
                                        <span class="qty-total">
                                            소계: <strong>{common.formatCurrency(item.untpc * (quantities[item.item_CODE] || 1))}원</strong>
                                        </span>
                                    {/if}
                                </div>
                            </div>
                        {/each}
                    </div>
                {/if}
            </div>

            <!-- 모달 푸터 -->
            <div class="item-modal-footer">
                <span class="selected-count">
                    선택: <strong>{selectedItemsMap.size}</strong>개
                </span>
                <div style="display: flex; gap: 8px;">
                    <button type="button" class="modal-cancel-btn" on:click={closeItemModal}>
                        취소
                    </button>
                    <button
                        type="button"
                        class="modal-confirm-btn"
                        disabled={selectedItemsMap.size === 0}
                        on:click={confirmSelection}
                    >
                        선택 완료
                    </button>
                </div>
            </div>
        </div>
    </div>
{/if}

<Modal open={showPhotoModal} imageUrl={PHOTO_FILE} onClose={() => (showPhotoModal = false)} />

<style>
    /* 달력 아이콘 잘림 방지 및 input 크기/패딩 안정화 */
    .cmn-input input.cmn-date-input,
    .cmn-input input.cmn-text-input {
        box-sizing: border-box !important;
        width: 100% !important;
        height: 44px !important;
        padding-left: 12px !important;
        padding-right: 12px !important;
        margin-top: 10px !important;
        border-radius: 3.5px !important;
        border: 1px solid var(--line, #ECECEC) !important;
        background: #FFFFFF !important;
        font-size: 14px;
        color: #1E293B;
    }

    /* Webkit 달력 아이콘 위치 여백 보정으로 아이콘 우측 잘림 방지 */
    .cmn-input input[type="date"]::-webkit-calendar-picker-indicator {
        cursor: pointer;
        padding: 4px;
        margin-right: 2px;
        opacity: 0.85;
    }

    /* 사용부품 입력란 + 부품선택 버튼 완벽한 수직 중앙 정렬 */
    .part-input-wrap {
        display: flex;
        align-items: center;
        gap: 8px;
        width: 100%;
        margin-top: 10px;
    }

    .part-input-wrap input {
        flex: 1;
        width: 0 !important;
        height: 44px !important;
        margin-top: 0 !important;
        padding-left: 12px !important;
        padding-right: 12px !important;
        box-sizing: border-box !important;
        border-radius: 3.5px !important;
        border: 1px solid var(--line, #ECECEC) !important;
        background: #FFFFFF !important;
        font-size: 14px;
        color: #1E293B;
    }

    .item-select-btn {
        height: 44px !important;
        margin-top: 0 !important;
        padding: 0 16px !important;
        background: #2D3C48;
        color: #FFFFFF;
        border: none;
        border-radius: 3.5px !important;
        font-size: 14px;
        font-weight: 600;
        white-space: nowrap;
        cursor: pointer;
        display: inline-flex;
        align-items: center;
        justify-content: center;
        box-sizing: border-box !important;
        flex-shrink: 0;
        transition: background 0.15s ease;
    }
    .item-select-btn:hover {
        background: #1E293B;
    }

    /* 부품 2개 이상 요약 바 (A안) */
    .part-summary-container {
        margin-top: 8px;
        width: 100%;
        display: flex;
        flex-direction: column;
    }

    .part-summary-bar {
        width: 100%;
        height: 38px;
        padding: 0 12px;
        background: #F8FAFC;
        border: 1px solid #CBD5E1;
        border-radius: 6px;
        display: flex;
        justify-content: space-between;
        align-items: center;
        cursor: pointer;
        transition: background 0.15s ease, border-color 0.15s ease;
        box-sizing: border-box;
    }

    .part-summary-bar:hover {
        background: #F1F5F9;
        border-color: #94A3B8;
    }

    .summary-text {
        font-size: 13px;
        color: #1E293B;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
    }

    .summary-text strong {
        color: #2D3C48;
    }

    .summary-toggle-btn {
        font-size: 12px;
        font-weight: 700;
        color: #2563EB;
        white-space: nowrap;
        margin-left: 8px;
    }

    .part-detail-dropdown {
        margin-top: 6px;
        background: #FFFFFF;
        border: 1px solid #E2E8F0;
        border-radius: 8px;
        padding: 10px 12px;
        box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.05);
    }

    .part-detail-header {
        font-size: 12px;
        font-weight: 700;
        color: #64748B;
        margin-bottom: 8px;
    }

    .part-tags-list {
        display: flex;
        flex-wrap: wrap;
        gap: 6px;
    }

    .part-tag-item {
        background: #F1F5F9;
        border: 1px solid #CBD5E1;
        border-radius: 6px;
        padding: 4px 8px;
        font-size: 13px;
        color: #1E293B;
        display: inline-flex;
        align-items: center;
        gap: 6px;
    }

    .part-tag-name {
        font-weight: 500;
    }

    .part-tag-del {
        background: transparent;
        border: none;
        color: #94A3B8;
        font-size: 12px;
        cursor: pointer;
        padding: 2px;
        line-height: 1;
        display: flex;
        align-items: center;
        justify-content: center;
        border-radius: 50%;
        transition: color 0.15s ease, background 0.15s ease;
    }

    .part-tag-del:hover {
        color: #EF4444;
        background: #FEE2E2;
    }

    /* 부품 선택 팝업 모달 */
    .item-modal-overlay {
        position: fixed;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        width: 100%;
        height: 100%;
        background: rgba(15, 23, 42, 0.65);
        backdrop-filter: blur(4px);
        display: flex;
        justify-content: center;
        align-items: center;
        z-index: 99999;
        padding: 14px;
        box-sizing: border-box;
    }

    .item-modal-container {
        width: 100%;
        max-width: 480px;
        height: 85vh;
        max-height: 800px;
        background: #FFFFFF;
        border-radius: 14px;
        box-shadow: 0 20px 25px -5px rgba(0, 0, 0, 0.2);
        display: flex;
        flex-direction: column;
        overflow: hidden;
    }

    .item-modal-header {
        padding: 14px 18px;
        background: #2D3C48;
        color: #FFFFFF;
        display: flex;
        justify-content: space-between;
        align-items: center;
    }

    .item-modal-header h3 {
        margin: 0;
        font-size: 16px;
        font-weight: 700;
        color: #FFFFFF;
    }

    .modal-close-icon {
        background: transparent;
        border: none;
        color: #CBD5E1;
        font-size: 20px;
        cursor: pointer;
        padding: 2px 6px;
        line-height: 1;
    }

    .item-modal-search {
        padding: 12px 14px;
        background: #F8FAFC;
        border-bottom: 1px solid #E2E8F0;
    }

    .modal-select {
        width: 100%;
        height: 38px;
        padding: 0 10px;
        border-radius: 6px;
        border: 1px solid #CBD5E1;
        font-size: 13px;
        background: #FFFFFF;
        color: #1E293B;
        box-sizing: border-box;
    }

    .modal-input {
        flex: 1;
        height: 38px;
        padding: 0 10px;
        border-radius: 6px;
        border: 1px solid #CBD5E1;
        font-size: 13px;
        background: #FFFFFF;
        color: #1E293B;
        box-sizing: border-box;
    }

    .modal-search-btn {
        height: 38px;
        padding: 0 16px;
        background: #2D3C48;
        color: #FFFFFF;
        border: none;
        border-radius: 6px;
        font-size: 13px;
        font-weight: 600;
        cursor: pointer;
        white-space: nowrap;
    }

    .item-modal-body {
        flex: 1;
        overflow-y: auto;
        padding: 12px 14px;
        background: #F1F5F9;
        display: flex;
        flex-direction: column;
        gap: 10px;
    }

    .empty-state {
        text-align: center;
        padding: 50px 0;
        color: #64748B;
        font-size: 14px;
    }

    .item-card-list {
        display: flex;
        flex-direction: column;
        gap: 8px;
    }

    .item-card {
        background: #FFFFFF;
        border: 1.5px solid #E2E8F0;
        border-radius: 8px;
        padding: 10px 12px;
        cursor: pointer;
        transition: all 0.15s ease;
    }

    .item-card:hover {
        border-color: #94A3B8;
        background: #FAFAFA;
    }

    .item-card.selected {
        border-color: #2D3C48;
        background: #F0F4F8;
    }

    .item-card-top {
        display: flex;
        align-items: center;
        gap: 8px;
    }

    .item-card-top input[type="checkbox"] {
        width: 18px;
        height: 18px;
        cursor: pointer;
        flex-shrink: 0;
    }

    .item-name {
        flex: 1;
        font-size: 14px;
        font-weight: 700;
        color: #1E293B;
        word-break: break-all;
    }

    .item-img-btn {
        padding: 4px 10px;
        background: #2D3C48;
        color: #FFFFFF;
        border: none;
        border-radius: 4px;
        font-size: 12px;
        font-weight: 600;
        cursor: pointer;
        flex-shrink: 0;
        transition: background 0.15s ease;
    }
    .item-img-btn:hover {
        background: #1E293B;
    }
    /* 수량 컨트롤 */
    .item-card-qty-row {
        margin-top: 8px;
        padding-top: 8px;
        border-top: 1px dashed #E2E8F0;
        display: flex;
        align-items: center;
        gap: 8px;
    }

    .qty-label {
        font-size: 13px;
        font-weight: 600;
        color: #475569;
        flex-shrink: 0;
    }

    .qty-control {
        display: flex;
        align-items: center;
    }

    .btn-minus, .btn-plus {
        width: 32px;
        height: 30px;
        border: 1px solid #CBD5E1;
        background: #FFFFFF;
        cursor: pointer;
        font-size: 16px;
        font-weight: 700;
        color: #1E293B;
        display: flex;
        justify-content: center;
        align-items: center;
        box-sizing: border-box;
    }

    .btn-minus {
        border-radius: 4px 0 0 4px;
        border-right: none;
    }

    .btn-plus {
        border-radius: 0 4px 4px 0;
        border-left: none;
    }

    .btn-minus:hover, .btn-plus:hover {
        background: #F1F5F9;
    }

    .qty-input {
        width: 44px;
        height: 30px;
        border: 1px solid #CBD5E1;
        text-align: center;
        font-size: 14px;
        font-weight: 600;
        color: #1E293B;
        background: #FFFFFF;
        box-sizing: border-box;
        margin: 0;
        padding: 0;
        border-radius: 0;
    }

    .qty-total {
        margin-left: auto;
        font-size: 12px;
        color: #64748B;
        white-space: nowrap;
    }

    .qty-total strong {
        color: #2D3C48;
        font-weight: 700;
    }

    .item-pick-btn {
        padding: 4px 10px;
        background: #059669;
        color: #FFFFFF;
        border: none;
        border-radius: 4px;
        font-size: 12px;
        font-weight: 600;
        cursor: pointer;
        flex-shrink: 0;
    }

    .item-card-info {
        margin-top: 6px;
        padding-left: 26px;
        display: flex;
        flex-wrap: wrap;
        gap: 10px;
        font-size: 12px;
        color: #64748B;
    }

    .item-modal-footer {
        padding: 10px 14px;
        background: #FFFFFF;
        border-top: 1px solid #E2E8F0;
        display: flex;
        justify-content: space-between;
        align-items: center;
    }

    .selected-count {
        font-size: 13px;
        color: #475569;
    }

    .selected-count strong {
        color: #2563EB;
        font-size: 15px;
    }

    .modal-cancel-btn {
        height: 36px;
        padding: 0 14px;
        background: #E2E8F0;
        color: #475569;
        border: none;
        border-radius: 6px;
        font-size: 13px;
        font-weight: 600;
        cursor: pointer;
    }

    .modal-confirm-btn {
        height: 36px;
        padding: 0 18px;
        background: #2D3C48;
        color: #FFFFFF;
        border: none;
        border-radius: 6px;
        font-size: 13px;
        font-weight: 700;
        cursor: pointer;
    }

    .modal-confirm-btn:disabled {
        background: #CBD5E1;
        cursor: not-allowed;
    }
</style>
